import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { createSearchParams, useNavigate, useSearchParams } from 'react-router-dom';
import AddressItem from '../../../../components/AddressItem';
import Icon, { Icons } from '../../../../components/Icon/Icon';
import PageHeader from '../../../../components/PageHeader';
import AppConfig from '../../../../config';
import { t } from '../../../../lang';
import RequestService from '../../../../services/RequestService';
import StorageService from '../../../../services/StorageService';
import TypesService from '../../../../services/TypesService';
import { topUpCardSlice } from '../../../../store/slices';

import './TopUpCardAccount.scss';

const { routes } = AppConfig;

const BlockchainsById = TypesService.BlockchainsById;
const CurrenciesById = TypesService.CurrenciesById;

const TopUpCardAccount = () => {
	const [addressesLoading, setAddressesLoading] = useState(false);
	const [card, setCard] = useState();
	const [asset, setAsset] = useState();

	const availableCurrencies = useSelector(store => store.app.availableCurrencies);
	const cardsList = useSelector(state => state.card.cardsList);
	const walletAddresses = useSelector(state => state.topUpCard.walletAddresses);
	const baseCurrencyAddresses = useSelector(state => state.topUpCard.baseCurrencyAddresses);

	const [searchParams] = useSearchParams();
	const navigate = useNavigate();
	const dispatch = useDispatch();

	const anotherCardsAddresses = cardsList
		.map(cardItem => {
			const address = cardItem?.Addresses?.find(address => address.CurrencyId === asset?.Id);
			if (cardItem.Id !== card?.Id && address) return address;
		})
		.filter(Boolean);
	const allSourceAddresses = [...walletAddresses, ...anotherCardsAddresses].sort((a, b) => b.AmountUsd - a.AmountUsd);

	const currencyData = CurrenciesById[asset?.Id];
	const blockchainData = BlockchainsById[currencyData?.BlockchainId];

	const getAddresses = async assetId => {
		try {
			setAddressesLoading(true);
			const response = await RequestService.GetAddressesByCurrency(assetId);
			setAddressesLoading(false);
			if (response?.Status === 'Success') {
				dispatch(topUpCardSlice.actions.setWalletAddresses(response.Addresses));
			}
		} catch (error) {
			console.log(error);
		}
	};

	const fetchBaseCurrencyAddresses = async () => {
		try {
			const feeCurrencyId = Object.keys(TypesService.CurrenciesById).find(currencyId => {
				const currency = TypesService.CurrenciesById[currencyId];
				return currency.BlockchainId === currencyData.BlockchainId && !currency.Standart;
			});
			const numericFeeCurrencyId = Number(feeCurrencyId) || 0;

			const response = await RequestService.GetAddressesByCurrency(numericFeeCurrencyId);
			if (response.Status === 'Success') {
				dispatch(topUpCardSlice.actions.setBaseCurrencyAddresses(response.Addresses));
			}
		} catch (error) {
			dispatch(topUpCardSlice.actions.setBaseCurrencyAddresses([]));
		}
	};

	useEffect(() => {
		const cardId = Number(searchParams.get('cardId'));
		setCard(cardsList.find(card => card.Id === cardId));

		const assetId = Number(searchParams.get('assetId'));
		setAsset(availableCurrencies.find(currency => currency.Id === assetId));

		dispatch(topUpCardSlice.actions.setIsMaxAmountSetted());
		dispatch(topUpCardSlice.actions.setAmount());
		StorageService.UpdateQuotes();
		getAddresses(assetId);
	}, []);

	useEffect(() => {
		if (currencyData?.FeeType === 'back_calculating' && !baseCurrencyAddresses.length) {
			fetchBaseCurrencyAddresses();
		}
	}, [asset]);

	const selectAddress = sourceAddress => {
		if (currencyData?.FeeType === 'back_calculating') {
			const feeCurrencyId = Object.keys(TypesService.CurrenciesById).find(currencyId => {
				const currency = TypesService.CurrenciesById[currencyId];
				return currency.BlockchainId === currencyData?.BlockchainId && !currency.Standart;
			});
			const numericFeeCurrencyId = Number(feeCurrencyId) || 0;
			const feeAddress = baseCurrencyAddresses.find(address => address.Address === sourceAddress.Address);
			const feeAddressAmount = feeAddress?.Amount || 0;
			const feeData = {
				CurrencyId: numericFeeCurrencyId,
				BlockchainId: CurrenciesById[feeCurrencyId].BlockchainId,
				Amount: feeAddressAmount,
				Fee: 0,
			};

			dispatch(topUpCardSlice.actions.setFeeData(feeData));
		} else {
			dispatch(topUpCardSlice.actions.setFeeData());
		}

		navigate({
			pathname: routes.topUpCardAmount,
			search: createSearchParams({ cardId: card.Id, assetId: asset.Id, addressId: sourceAddress.AddressId }).toString(),
		});
	};

	return (
		<div className='TopUpCardAccount'>
			<PageHeader
				header={'Select address'}
				subheader={<>{currencyData?.Name + ' ' + blockchainData?.Name + ' ' + currencyData?.Standart}</>}
				icon={currencyData?.CompanyIcon}
				iconLabel={currencyData?.CompanyIcon !== blockchainData?.Icon ? blockchainData?.Icon : null}
			/>
			<div className='TopUpCardAccount__body'>
				{allSourceAddresses.length || addressesLoading ? (
					<div className='FormBlock'>
						{allSourceAddresses.map((address, index) => (
							<AddressItem
								key={index}
								address={address}
								lastItem={index === allSourceAddresses.length - 1}
								onClick={selectAddress}
							/>
						))}
					</div>
				) : (
					<div className='TopUpCardAccount__empty-state'>
						<Icon type={Icons.EMPTY_ACCOUNT_LIST_ICON} width={240} height={124} />
						<div className='TopUpCardAccount__empty-header'>{t('No addresses yet')}</div>
					</div>
				)}
			</div>
		</div>
	);
};

export default TopUpCardAccount;
